import { Countries } from './paymentproduct/Countries';
import { ProductChannel } from './paymentproduct/ProductChannel';
import { ProductType } from './paymentproduct/ProductType';
export const PaymentProductItem = {
    countries: Countries,
    product_channel: ProductChannel,
    product_type: ProductType,
};
